export default __webpack_public_path__ + "assets/profeature-private-annotations.b4c8d264eb3fa1356322ec29d64138c0.jpg";